/**
 * FormaSubBar — the white nav bar under FormaTopBar showing the
 * "Data Management" section and the current project crumb. Mirrors
 * the SVG mockup's 62px sub-header. Cosmetic only; the demo-surface
 * ViewToggle is rendered globally in main.tsx as a fixed overlay so
 * it stays in the same screen position when the user flips between
 * Standalone and Forma views.
 */
import { useCurrentProject } from "../../stores/projectStore";
import { FORMA } from "./FormaTokens";

export function FormaSubBar() {
  const p = useCurrentProject();
  return (
    <div
      style={{
        height: 62,
        background: FORMA.panelBg,
        borderBottom: `1px solid ${FORMA.borderSoft}`,
        display: "flex",
        alignItems: "center",
        padding: "0 14px",
        gap: 14,
        flexShrink: 0,
        color: FORMA.textPrimary,
      }}
    >
      <SectionTitle />
      <Divider />
      <ProjectCrumb
        projectName={p.projectName}
        subtitle="Forma Data Management"
      />
      <span
        style={{
          marginLeft: "auto",
          display: "flex",
          gap: 12,
          alignItems: "center",
        }}
      >
        <Search />
        <UserAvatar initials="HO" />
      </span>
    </div>
  );
}

function SectionTitle() {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div
        aria-hidden
        style={{
          width: 32,
          height: 32,
          borderRadius: 4,
          background: FORMA.blueSoftBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: FORMA.blue,
          fontSize: 16,
        }}
      >
        ◫
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <span style={{ fontSize: 14, fontWeight: 600 }}>Data Management</span>
        <span style={{ color: FORMA.textSecondary, fontSize: 12 }}>⌄</span>
      </div>
    </div>
  );
}

function Divider() {
  return (
    <span
      aria-hidden
      style={{
        width: 1,
        height: 32,
        background: "#e1e5ea",
      }}
    />
  );
}

function ProjectCrumb({
  projectName,
  subtitle,
}: {
  projectName: string;
  subtitle: string;
}) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div
        aria-hidden
        style={{
          width: 28,
          height: 28,
          borderRadius: 4,
          background: "#f2f3f5",
          border: "1px solid #d8dde3",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#69717d",
          fontSize: 14,
        }}
      >
        ◫
      </div>
      <div
        style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}
      >
        <span
          style={{ fontSize: 14, fontWeight: 600, color: FORMA.textPrimary }}
        >
          {projectName}
        </span>
        <span style={{ fontSize: 11, color: "#4b5563" }}>{subtitle}</span>
      </div>
    </div>
  );
}

function Search() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "6px 10px",
        border: `1px solid ${FORMA.borderHard}`,
        borderRadius: 4,
        background: "#fff",
        color: "#9aa3af",
        fontSize: 12,
        width: 220,
      }}
    >
      <span aria-hidden>⌕</span>
      <span>Search files, folders, issues…</span>
    </div>
  );
}

function UserAvatar({ initials }: { initials: string }) {
  return (
    <span
      role="img"
      aria-label="Account"
      style={{
        width: 30,
        height: 30,
        borderRadius: "50%",
        background: FORMA.topBarBg,
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        fontWeight: 700,
      }}
    >
      {initials}
    </span>
  );
}
